import AssociatedContactsSelector from '@app/components/AssociatedContactsSelector'
import DateSelector from '@app/components/DateSelector'
import FormGroupRenderer from '@app/components/FormGroupRenderer'
import { AssociatedContact } from '@app/models/AssociatedContact'
import { IComp } from '@app/models/Comp'
import {
  ITransactionHistory,
  TransactionHistory,
} from '@app/models/TransactionHistory'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { actionCreators } from '../modules/transactionHistory'

interface IComponentProps {
  cancelModal: (e: boolean) => void
  confirmClick: (e: any) => void
  className?: string
  comp?: IComp
  isOpen: boolean
  onChange?: (e: ITransactionHistory) => void
  persistToServer: boolean
  propertyId: string
  style?: React.CSSProperties
  transaction?: ITransactionHistory
}

interface IComponentState {
  mode: string
  transaction: TransactionHistory
}

export default class TransactionHistoryModal extends React.PureComponent<
  IComponentProps & typeof actionCreators,
  IComponentState
> {
  constructor(props: any) {
    super(props)

    this.state = {
      mode: this.props.transaction ? 'editing' : 'adding',
      transaction:
        (this.props.transaction as TransactionHistory) ||
        new TransactionHistory(),
    }

    bindFunctions(this)
  }

  public render() {
    return (
      <Modal
        size='lg'
        centered
        isOpen={this.props.isOpen}
        toggle={() => this._cancelClick(!this.props.isOpen)}
      >
        <ModalHeader toggle={() => this._cancelClick(!this.props.isOpen)}>
          New Transaction
        </ModalHeader>
        <ModalBody>{this._renderFields()}</ModalBody>
        <ModalFooter>
          <Button
            color='secondary'
            outline
            onClick={() => this._cancelClick(false)}
          >
            <FontAwesomeIcon icon={['fal', 'times']} fixedWidth /> Cancel
          </Button>
          <Button color='primary' onClick={this._confirmAction}>
            <FontAwesomeIcon icon={['fal', 'trash']} /> OK
          </Button>
        </ModalFooter>
      </Modal>
    )
  }

  private _cancelClick(value: boolean) {
    this.props.cancelModal(value)

    if (this.state.mode === 'adding') {
      this.setState({
        transaction: new TransactionHistory(),
      })
    }
  }

  private _confirmAction() {
    if (this.state.mode === 'adding') {
      this.props.saveTransaction(
        this.props.persistToServer,
        this.props.propertyId,
        this.props.transaction || this.state.transaction,
        this.props.confirmClick,
        this.props.comp,
      )

      this.setState({
        transaction: new TransactionHistory(),
      })
    } else {
      this.props.confirmClick(this.state.transaction)
    }
  }

  private _renderFields() {
    const transaction = this.state.transaction

    return (
      <div>
        <FormGroupRenderer labelText='Owner(s)'>
          <AssociatedContactsSelector
            className='w-100'
            onChange={this._setTransactionOwners}
            placeholder='Add owner(s) for this transaction...'
            value={transaction.owners}
          />
        </FormGroupRenderer>

        <FormGroupRenderer
          labelText='Sale Price'
          type='number'
          value={transaction.salePrice}
          onChange={this._setSalePrice}
        />

        <FormGroupRenderer labelText='Sale Date'>
          <DateSelector
            value={transaction.saleDate}
            onChange={this._setSaleDate}
          />
        </FormGroupRenderer>
      </div>
    )
  }

  private _setSaleDate(value?: number) {
    const transaction = this.state.transaction.set(
      'saleDate',
      value || 0,
    ) as TransactionHistory

    this.setState({
      transaction,
    })

    if (this.props.onChange) {
      this.props.onChange(transaction)
    }
  }

  private _setSalePrice(value: number) {
    const transaction = this.state.transaction.set(
      'salePrice',
      value,
    ) as TransactionHistory

    this.setState({
      transaction,
    })
  }

  private _setTransactionOwners(value: List<AssociatedContact>) {
    const transaction = this.state.transaction.set(
      'owners',
      value,
    ) as TransactionHistory

    this.setState({
      transaction,
    })
  }
}
